/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:51:24
 * @LastEditTime: 2024-03-25 11:01:20
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-statistic-analy\modules\companyFlowStatisRouter.js
 * 公司流向统计
 */
import store from '@/store'
import { getAuthClientList } from '@/api/common'
const companyFlowStatisRouter = [
  // 销售排名分析
  {
    path: '/flowSystem/client-sales-ranking-statistics',
    name: 'flowSystemStatisticsClientSalesRanking',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics2" */
      //   '../views/flowSystem/statistics/ClientSalesRanking.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics2" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/sales/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '销售排名分析',
    },
  },
  // 产品销售统计
  {
    path: '/flowSystem/goods-sales-statistics',
    name: 'flowSystemStatisticsGoodsSales',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics1" */
      //   '../views/flowSystem/statistics/GoodsSales.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/product/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '产品销售统计',
    },
  },
  // 全国产品销售统计
  {
    path: '/flowSystem/all-region-goods-sales-statistics',
    name: 'flowSystemStatisticsGoodsSales',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/all-region-product/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '全国产品销售统计',
    },
  },
  // 区域销售统计
  {
    path: '/flowSystem/all-region-sales-statistics',
    name: 'flowSystemStatisticsRegionSales',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/region-sale/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '区域销售统计',
    },
  },
  // 省份销售统计
  {
    path: '/flowSystem/province-sales-statistics',
    name: 'flowSystemStatisticsProvinceSales',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics1" */
      //   '../views/flowSystem/statistics/ProvinceSales.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/province/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '省份销售统计',
    },
  },
  // 部门销售统计
  // randomId -1 默认筛选,第一级
  {
    path: '/flowSystem/department-sales-statistics/:randomId',
    name: 'flowSystemStatisticsDepartmentSales',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics3" */
      //   '../views/flowSystem/statistics/DepartmentSales.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/department/Page.vue'
      ), //新迁移文件
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '部门销售统计',
    },
  },
  // 部门销售统计-历史组织架构
  {
    path: '/flowSystem/department-sales-history-statistics/:dataType/:randomId',
    name: 'flowSystemStatisticsDepartmentSalesHistory',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics3" */
      //   '../views/flowSystem/statistics/DepartmentSalesHistory.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/department/HistoricalOrganStruct.vue'
      ),  //新迁移文件
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '部门销售统计-历史组织架构',
      breadcrumb: [
        {
          title: '部门销售统计',
          name: 'flowSystemStatisticsDepartmentSales',
        },
      ],
    },
  },
  // 岗位销售统计
  {
    path: '/flowSystem/job-sales-statistics',
    name: 'flowSystemStatisticsJobSales',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/statistics/JobSales.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/post/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '岗位销售统计',
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 岗位销售统计 > 历史组织架构
  {
    path: '/flowSystem/history-organization-examine-gw',
    name: 'flowSystemHistoryOrganizationExamineGw',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/historyOrganizationExamineGw.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/post/HistoricalOrganStruct.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '岗位销售统计-历史组织架构',
      breadcrumb: [
        {
          title: '岗位销售统计',
          name: 'flowSystemStatisticsJobSales',
        },
      ],
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 绩效奖金明细表
  {
    path: '/flowSystem/PerformancePonusDetails',
    name: 'flowSystemStatisticsPerformance',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/statistics/PerformancePonusDetails.vue'
      // ), 待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/performance-bonus-detail/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '绩效奖金明细表',
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  //导入绩效奖金明细表明细
  {
    path: '/flowSystem/PerformancePonusDetailsImport',
    name: 'flowSystemPerformancePonusDetailsImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/PerformancePonusDetailsImport.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/performance-bonus-detail/Import.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '导入绩效奖金明细',
      breadcrumb: [
        {
          title: '绩效奖金明细表',
          name: 'flowSystemStatisticsPerformance',
        },
      ],
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  //导出绩效奖金明细表明细
  {
    path: '/flowSystem/PerformancePonusDetailsExport',
    name: 'flowSystemPerformancePonusDetailsExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/PerformancePonusDetailsExport.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/company-flow-statis/performance-bonus-detail/Export.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '公司流向统计', //二级菜单
      title: '导出绩效奖金明细',
      breadcrumb: [
        {
          title: '绩效奖金明细表',
          name: 'flowSystemStatisticsPerformance',
        },
      ],
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
]
export default companyFlowStatisRouter
